<template>
  <div class="app-config-loader flex-column justify-content-center align-items-center d-flex">
    <BImg src="/loading.gif" fluid alt="Responsive image" width="400" height="300"></BImg>
    <h5 class="text-muted loading-text">{{ loadingMessage }}</h5>
  </div>
</template>

<script lang="ts">
import { oidcChannel } from "@/core/broadcast/broadcast";
import { CDIdentityModule } from "@/core/store/modules/cd-identity-module";
import { AppModule } from "@/core/store/modules/app-module";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { BImg } from "bootstrap-vue-next";

export default defineComponent({
  name: "LoginCallback",
  components: { BImg },
  data() {
    return {
      loadingMessage: "Completing Sign In...",
      router: useRouter()
    };
  },
  async mounted(): Promise<void> {
    await (this as any).$store
      .dispatch("oidcSignInCallback")
      .then(this.completeSignIn)
      .catch((err: any) => {
        console.log(err);
        this.router.push({ name: "AuthenticationError" });
      });
  },
  methods: {
    async completeSignIn(redirectPath: string) {
      const user = (this as any).$store.getters.oidcUser;

      this.loadingMessage = "Loading Coats Digital Identity...";
      await CDIdentityModule.LoadOrganisation({
        idp: user["idp"],
        cdOrganisationId: user["cd_organisation_id"]
      });

      await CDIdentityModule.LoadUser({
        idp: user["idp"],
        cdUserId: user["cd_user_id"]
      });

      try {
        await (this as any).$store.dispatch("clearStaleState");
      } catch {
        await this.router.push({ name: "InternalServerError" });
      }

      this.loadingMessage = "Getting Application Configuration...";
      await AppModule.GetConfig();
      this.loadingMessage = "Redirecting to Dashboard...";
      setTimeout(async () => {
        oidcChannel.postMessage("user-login-success");
        await this.router.push(redirectPath);
      }, 250);
    }
  }
});
</script>
<style lang="scss" scoped>
.app-config-loader {
  background-color: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
}

.loading-text {
  position: absolute;
  top: calc(50% + 50px);
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
